var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-text-input',{attrs:{"label":_vm.$t('integrations.fields.tenant'),"readonly":true},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})}
var staticRenderFns = []

export { render, staticRenderFns }